import { usePadding } from "@/components/utils/Padding";
import { TextPropTypes } from "./propTypes";
import "./styles.scss";

const Text = (props) => {
  const {
    display_text_order: displayTextOrder,
    display_text: displayText,
    text_content: textContent,
    text_order: textOrder,
    text_padding: textPadding,
  } = props;

  const paddingStyle = usePadding(textPadding);

  if (!displayText || !textContent) {
    return null;
  }

  const eyebrowStyle = {
    ...paddingStyle,
    ...(displayTextOrder && { order: textOrder || 0 }),
  };

  return (
    <div
      className="text-component"
      style={eyebrowStyle}
      dangerouslySetInnerHTML={{ __html: textContent }}
    />
  );
};

Text.propTypes = TextPropTypes;

export default Text;
